import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-broken-sync-alert-template',
  styleUrls: ['../../global-styles.less', './broken-sync-alert.component.less'],
  templateUrl: './broken-sync-alert.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class BrokenSyncAlertTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<BrokenSyncAlertTemplateData>;
}

export type BrokenSyncAlertTemplateData = {
  title: string;
  description: string;
  technical_details_html: string;
  go_to_settings_text: string;
  go_to_settings_link: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const BrokenSyncAlertTemplateMocks: BrokenSyncAlertTemplateData[] = [
  {
    title: 'We could not connect your mailbox',
    description: 'We’ve noticed a problem with your connected mailbox.',
    technical_details_html:
      "If you've recently changed your password or activated the 2FA feature, <b>try reconnecting your mailbox in settings</b>. Or, go to our tutorial <a href='#'>How to resolve mailbox connection issues?</a>",
    go_to_settings_text: 'Go to email settings',
    go_to_settings_link: 'https://app.s.recruitee.com/#/settings/profile/email_settings',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
